/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

// スクロールバーを除いたウィンドウ幅をCSSのカスタムプロパティに設定
const setVw = function() {
  const vw = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;

    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

//スライダー
$(function(){
  $('.home-kv__slick').each(function(index, el) {
    const $slider = $(this);

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      fade: true,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: false
    });
  });
});

//フェード
$(function(){
  var fade = $('.u-fade, .js-fadeAni');

  fade.each(function(index, el) {
    var t = $(this);

    setTimeout(function(){
      $(window).on('resize scroll', function(event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if(h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if(sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if(d) {
        pointD = d;
      }

      if(window.matchMedia('(max-width: 991px)').matches) {
        var d2 = t.attr('data-fade-delay-sp');
        if(d2) {
          pointD = d2;
        }
      }

      if(pointH < pointSc) {
        setTimeout(function(){
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if(nextStr) {
        var nextArr = nextStr.split(' ');
        if(nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if(nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 200;
              if(nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 200;
              if(nextDelay) {
                step = delay;
              }
              if(nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function(index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function(){
                  t2.addClass('is-fadeNext');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

$(function(){
  $('.p-fixBtns').each(function (index, element) {
    const $fix = $(this);
    const $fixBg = $('.p-fixBtns__bg');
    const $sec = $('.home-about');

    if($sec[0]) {
      $(window).on('scroll', function () {
        run();
      });

      run();

      function run() {
        if($(window).scrollTop() + $(window).innerHeight() / 2 > $sec.offset().top) {
          $fix.addClass('is-on');
          $fixBg.addClass('is-on');
        } else {
          $fix.removeClass('is-on');
          $fixBg.removeClass('is-on');
        }
      }
    } else {
      $fix.addClass('is-on');
      $fixBg.addClass('is-on');
    }
  });
});

$(function(){
  const $btn = $('.home-tabsTtl__btn button');

  if($btn[0]) {
    const $btns = $('.home-tabsTtl__ttl');
    const $btnsSP = $('.home-tabsTtl__ttl');
    const $tab = $('.tab-con');
    const $close = $('.tab-bottom__close button');

    $btn.on('click', function () {
      const $t = $(this);
      const $tar = $('.tab-con[data-tab-id="' + $t.attr('data-tab-target') + '"]');

      if($t.hasClass('is-on')) {
        $btn.removeClass('is-off is-on');
  
        $tab.stop().slideUp(600);
      } else {
        $btn.removeClass('is-on').addClass('is-off');
        $t.removeClass('is-off').addClass('is-on');

        if($tar[0]) {
          $tab.stop().slideUp(0);
          $tar.stop().slideDown(600);
        }
      }
    });

    $close.on('click', function () {
      $btn.removeClass('is-off is-on');

      $tab.stop().slideUp(300);
      
      let position = 0;

      if(window.matchMedia('(max-width:991px)').matches) {
        position = $btnsSP.offset().top - 20;
      } else {
        position = $btns.offset().top - 20;
      }

      $("html, body").animate({scrollTop:position}, 300, "swing");
    });
  }
});

$(function(){
  $('.home-kv__entry').each(function (index, element) {
    const $root = $(this);
    const $kv = $('.home-kv');
    let timer1;
    let timer2;

    timer1 = setInterval(function(){
      if($kv.hasClass('is-fade')) {
        timer2 = setTimeout(function(){
          $root.addClass('is-fade');
          clearInterval(timer2);
        }, 1600);
        clearInterval(timer1);
      }
    }, 10);

    run();
    $(window).on('scroll', function () {
      run();
    });

    function run() {
      if($(window).scrollTop() > 50) {
        $root.addClass('is-fade');
        clearInterval(timer1);
        clearInterval(timer2);
      }
    }
  });
});

  /* -------------------------------------------------
  外部リンク 確認ダイアログ
  ------------------------------------------------- */
  $(function () {
    $.getJSON("./assets/js/jump_page_config.json", function(config){

      var jumpPage_noUse = config.jumpPage_noUse; // ジャンプページを経由しないURLリスト
      var jumpPage_use = config.jumpPage_use; // 経由しないリストのうち特別にジャンプページを経由するURLリスト

      if($("body.jumpPage").length === 0){

        $(document).on("click", "a[href^='http'],a[href^='//']", function(e) {
          console.log(('ok'));
          
          if($(this).hasClass('js-noJumpPage')) return true;
          console.log(('ok2'));

          var href = $(this).attr("href");
          var href_encoded = encodeURIComponent(href);
          var sitename = $(this).attr('data-sitename') ? encodeURIComponent($(this).attr('data-sitename')) : "外部サイト";
          var sitename_sub = $(this).attr('data-sitename-sub') ? encodeURIComponent($(this).attr('data-sitename-sub')) : "";
          var main_text = $(this).attr('data-main-text') ? encodeURIComponent($(this).attr('data-main-text')) : "";

          // クリックしたURLがjumpPage_noUseに含まれていないこと。
          var empty_jumpPage_noUse = jumpPage_noUse.filter(function(url, index){
            var pattern = RegExp(url);
            return pattern.test(href);
          }).length === 0;

          // クリックしたURLがjumpPage_useに含まれていないこと。
          var empty_jumpPage_use = jumpPage_use.filter(function(url, index){
            var pattern = RegExp(url);
            return pattern.test(href);
          }).length === 0;

          var jumpPageNeeded = empty_jumpPage_noUse || !empty_jumpPage_use;

          if(jumpPageNeeded) {
            e.preventDefault();
            var query = '?href=' + href_encoded + '&sitename=' + sitename;
            if(sitename_sub !== "") {
              query += '&sitename_sub=' + sitename_sub;
            }
            if(main_text !== "") {
              query += '&main_text=' + main_text;
            }
            window.open('https://www.higobank.co.jp/jump/' + query, '_blank');
          }
        });

      }

    });

  });


$(function () {
  /* -------------------------------------------------
  SP 電話番号リンク化
  ------------------------------------------------- */
  var device;
  var ua = navigator.userAgent;
  var BREAK_POINT = 768;
  var scrollPosition;
  var overlaySpeed = 500;
  var locationPath = location.pathname
  
  $(window).on('load', function() {
    if (window.innerWidth < BREAK_POINT) {
      $(".telNumber").each(function() {
        if ($(this).children("span.num").length) {
          // spanあり
          var span = $(this).children("span");
          var num = span.text();
          var numNoHyphen = num.replace(/[^0-9]/g, "");
          var link = '<a href=tel:"'+numNoHyphen+'">'+$(this).html()+'</a>';
          span.replaceWith(link);
        } else {
          // spanなし
          var num = $(this).text();
          var numNoHyphen = num.replace(/[^0-9]/g, "");
          var link = '<a href=tel:"'+numNoHyphen+'">'+$(this).html()+'</a>';
          $(this).empty().append(link);
        }
      });
    }
  });
});
